import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\AccountingDiary\CreateAccountingDiaryController::__invoke
* @see app/Http/Controllers/AccountingDiary/CreateAccountingDiaryController.php
* @route '/api/accounting-diary'
*/
const CreateAccountingDiaryController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAccountingDiaryController.url(options),
    method: 'post',
})

CreateAccountingDiaryController.definition = {
    methods: ["post"],
    url: '/api/accounting-diary',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\AccountingDiary\CreateAccountingDiaryController::__invoke
* @see app/Http/Controllers/AccountingDiary/CreateAccountingDiaryController.php
* @route '/api/accounting-diary'
*/
CreateAccountingDiaryController.url = (options?: RouteQueryOptions) => {
    return CreateAccountingDiaryController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\AccountingDiary\CreateAccountingDiaryController::__invoke
* @see app/Http/Controllers/AccountingDiary/CreateAccountingDiaryController.php
* @route '/api/accounting-diary'
*/
CreateAccountingDiaryController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateAccountingDiaryController.url(options),
    method: 'post',
})

export default CreateAccountingDiaryController